import { render, staticRenderFns } from "./TransactionModuleChart.vue?vue&type=template&id=1595b72a&"
import script from "./TransactionModuleChart.vue?vue&type=script&lang=js&"
export * from "./TransactionModuleChart.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports